import { ArrowDropDown, CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { Box, Button, Divider, Menu, MenuItem } from "@mui/material";
import { Fragment, useCallback, useState } from "react";
import { usePersistantStore } from "@/stores/global";

export default function HorizontalCalendarSettings() {
  const settings = usePersistantStore((state) => state.getSettings());
  const setSettings = usePersistantStore((state) => state.setSettings);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [draftSettings, setDraftSettings] = useState(settings);

  const open = !!anchorEl;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setDraftSettings(settings);
    setAnchorEl(event.currentTarget);
  };

  const close = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <Fragment>
      <Button onClick={handleClick} endIcon={<ArrowDropDown />}>
        Ansicht
      </Button>
      <Menu open={open} anchorEl={anchorEl} onClose={close}>
        {[
          { key: "hcIncludeCrews", name: "Kolonnen" },
          { key: "hcIncludeCrewMembers", name: "Kolonnenmitglieder" },
          { key: "hcIncludeHumans", name: "Zusätzliche Mitarbeiter" },
          { key: "hcIncludeResources", name: "Geräte" },
          { key: "hcIncludeNotes", name: "Notizen" },
        ].map((x) => (
          <MenuItem
            onClick={() => {
              setDraftSettings((current) => ({ ...current, [x.key]: !current[x.key] }));
            }}
            key={x.key}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              {draftSettings[x.key] ? <CheckBox /> : <CheckBoxOutlineBlank />}
              <div>{x.name}</div>
            </div>
          </MenuItem>
        ))}
        <Divider />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, px: 1 }}>
          <Button onClick={close}>Abbrechen</Button>
          <Button
            variant="contained"
            onClick={() => {
              setSettings(draftSettings);
              close();
            }}
          >
            Speichern
          </Button>
        </Box>
      </Menu>
    </Fragment>
  );
}
